import { BrowserRouter as Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import { Switch, Route,Redirect } from "react-router-dom";
import Login from "../Login/Login";
import SignUp from "../SignUp/SignUp";
import ForgotPassword from "../Login/ForgotPassword";
import VerifyEmail from "../SignUp/VerifyEmail";
import Verify from "../SignUp/Verify";
import ForgotPasswordVerify from "../Login/ForgotPasswordVerify";
import UnSubScribe from "../UnsubScribe/UnSubScribe";
import LinkClicked from "../LinkClicked/LinkClicked";
import GoogleVerify from "../DashBoard/GoogleLogin";
import Meter from "../Login/Meter";
import ListLocation from "../Login/ListLocation";
export default function Routes() {

  var history = createBrowserHistory();
  return (
    <Router history={history}>  
      <Switch>
     
        <Route exact path="/Login" component={Login}></Route>
        <Route exact path="/Meter" component={Meter}></Route>
        <Route exact path="/ListLocation" component={ListLocation}></Route>
        <Route exact path="/SignUp" component={SignUp}></Route>
        <Route exact path="/VerifyEmail" component={VerifyEmail}></Route>
        <Route exact path="/Google-Verify/:status/:message" component={GoogleVerify}></Route>
        <Route exact path="/verify/:id" component={Verify}></Route>
        <Route exact path="/userclicked" component={LinkClicked}></Route>
        <Route exact path="/ForgotPassword" component={ForgotPassword}></Route>
        <Route exact path="/UnSubscribe/:mail/:id" component={UnSubScribe}></Route>
        <Route exact path="/ForgotPassword-verify/:id" component={ForgotPasswordVerify}></Route>
        <Redirect from="" to="/Login" />
      </Switch>
    </Router>
  );
}
